import React, { Suspense, lazy } from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import About from "../components/About";
import Services from "../components/Services";
import FutureMobility from "../components/FutureMobility";
import Partner from "../components/Partner";
import Opportunities from "../components/Opportunities";
import WhyChooseUs from "../components/WhyChooseUs";
import News from "../components/News";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
const EnquiryModal = lazy(() => import("../components/EnquiryModal"));

export default function Home() {
  return (
    <div data-testid="home-page" className="relative">
      <Header />
      <Suspense fallback={null}>
        <EnquiryModal />
      </Suspense>
      <main>
        <Hero />
        <About />
        <Services />
        <FutureMobility />

        <Partner />
        <Opportunities />
        <WhyChooseUs />
        <News />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
